import React, { useState } from "react";
import Wsp from "../../contact/Component/Floatingwsp";
import "./ContactUs.css";

const ContactUs = (props) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!firstName) newErrors.firstName = "First Name is required.";
    if (!mobile) newErrors.mobile = "Mobile Number is required.";
    if (!address) newErrors.address = "Address is required.";
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      props.AddContactForm1(firstName, lastName, email, mobile, address);
      setFirstName("");
      setLastName("");
      setEmail("");
      setMobile("");
      setAddress("");
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
    <div className="cu-root">

      {/* ── HERO ── */}
      <section className="cu-hero">
        <div
          className="cu-hero__bg"
          style={{
            backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fmgcentralintr.jpeg?alt=media&token=fc24a189-bb82-410a-9bd5-7c14ab0ee4f3')`,
          }}
        />
        <div className="cu-hero__overlay" />

        <div className="cu-hero__content">
          <p className="cu-hero__eyebrow">Feel free to get in touch with us</p>

          <h1 className="cu-hero__title">Connect With Excellence</h1>

          <p className="cu-hero__sub">Let's Start The Dialogue</p>

          <p className="cu-hero__desc">
            Our elite team of Kia consultants is at your service.
            Experience a new standard of automotive hospitality.
          </p>

          <div className="cu-hero__actions">
            <button
              className="cu-btn cu-btn--primary"
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/dir/?api=1&destination=Kia+Showroom+Bhubaneswar",
                  "_blank"
                )
              }
            >
              Get Direction
            </button>
            <a
              href={`tel:+91${process.env.REACT_APP_CONTACT_PHONE}`}
              className="cu-btn cu-btn--ghost"
            >
              Call Now
            </a>
          </div>
        </div>
      </section>

      {/* ── FORM SECTION ── */}
      <section className="cu-form-section">

        {/* left info panel */}
        <div className="cu-info">
          <span className="cu-info__tag">Reach Out</span>
          <h2 className="cu-info__heading">Contact Us</h2>

          <ul className="cu-info__list">
            <li className="cu-info__item">
              <div>
                <p className="cu-info__item-label">Call Us At</p>
                <a
                  href={`tel:+91${process.env.REACT_APP_CONTACT_PHONE}`}
                  className="cu-info__item-value"
                >
                  {process.env.REACT_APP_CONTACT_PHONE}
                </a>
              </div>
            </li>
            <li className="cu-info__item">
              <div>
                <p className="cu-info__item-label">Mail Us At</p>
                <a
                  href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}
                  className="cu-info__item-value"
                >
                  {process.env.REACT_APP_CONTACT_EMAIL}
                </a>
              </div>
            </li>
            <li className="cu-info__item">
              <div>
                <p className="cu-info__item-label">Showroom</p>
                <p className="cu-info__item-value">Bhubaneswar, Odisha</p>
              </div>
            </li>
          </ul>

          <div className="cu-info__note">
            Fill the form and our consultant will call you back shortly.
          </div>
        </div>

        {/* form card */}
        <div className="cu-form-card">
          {submitted && (
            <div className="cu-success">
              Thank you! We will reach out to you shortly.
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="cu-field-row">
              <div className="cu-field">
                <label className="cu-label">
                  First Name <sup className="cu-required">*</sup>
                </label>
                <input
                  className={`cu-input${errors.firstName ? " cu-input--error" : ""}`}
                  placeholder="Enter First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                {errors.firstName && (
                  <span className="cu-error-msg">{errors.firstName}</span>
                )}
              </div>

              <div className="cu-field">
                <label className="cu-label">Last Name</label>
                <input
                  className="cu-input"
                  placeholder="Enter Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>

            <div className="cu-field-row">
              <div className="cu-field">
                <label className="cu-label">Email ID</label>
                <input
                  className="cu-input"
                  type="email"
                  placeholder="Enter Email ID"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="cu-field">
                <label className="cu-label">
                  Mobile No. <sup className="cu-required">*</sup>
                </label>
                <input
                  className={`cu-input${errors.mobile ? " cu-input--error" : ""}`}
                  placeholder="Enter Mobile Number"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />
                {errors.mobile && (
                  <span className="cu-error-msg">{errors.mobile}</span>
                )}
              </div>
            </div>

            <div className="cu-field cu-field--full">
              <label className="cu-label">
                Address <sup className="cu-required">*</sup>
              </label>
              <textarea
                className={`cu-input cu-textarea${errors.address ? " cu-input--error" : ""}`}
                placeholder="Enter Your Address"
                rows={4}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              {errors.address && (
                <span className="cu-error-msg">{errors.address}</span>
              )}
            </div>

            <div className="cu-form-footer">
              <button type="submit" className="cu-btn cu-btn--submit">
                Submit Enquiry &rarr;
              </button>
            </div>
          </form>
        </div>
      </section>

      <Wsp />
    </div>
  );
};

export default ContactUs;